import { withPrefix } from 'gatsby';
import ButtonWithIcon from '@vfuk/core-button-with-icon';
import { IconStepperProps } from '@vfuk/core-icon-stepper';
import usingOpcoUrl from '@/helpers/prefixHelper';

interface NextButtonProps {
  step: number;
  steps: IconStepperProps['steps'];
  disableSteps?: boolean;
  handleClickButton: () => void;
}

const NextButton = ({ step, steps, disableSteps = false, handleClickButton }: NextButtonProps) => {
  const lastStep = step === steps.length - 1;

  return (
    <ButtonWithIcon
      {...(lastStep && { styles: { borderColor: '#080808' } })}
      icon={{
        name: 'chevron-right',
        justify: 'right',
      }}
      text={disableSteps || lastStep ? 'Go to basket' : 'Next'}
      appearance={disableSteps || lastStep ? 'primary' : 'secondary'}
      {...((disableSteps || step < steps.length - 1) && { onClick: handleClickButton })}
      {...(!disableSteps && lastStep && { href: usingOpcoUrl(withPrefix('/marketplace/product-list/basket')) })}
      htmlAttributes={{
        dataAttributes: {
          'data-selector': `${disableSteps || lastStep ? 'config basket button' : 'config next button'}`,
        },
      }}
    />
  );
};

export default NextButton;
